import app from '../main';

const state = {lang: 'jp'};

const actions = {
    setLang ({ dispatch, commit }, payload) {
        commit('setLang', payload);
    },

    async setLangNew ({commit}, payload) {
        if (payload in app.$i18n.messages) {
            commit('setLang', payload);
        } else {
            try {
            // const res = await axios.get(`../lang/${payload}.json`)
                const res = await import(`../lang/${payload}.json`);
                app.$i18n.setLocaleMessage(payload, res);
                commit('setLang', payload);
            } catch (e) {
                console.log(e);
            }
        }
    },
};

const mutations = {
    setLang (state, payload) {
        app.$i18n.locale = payload;
        state.lang = payload;
    },
};

export const lang = {
    namespaced: true,
    state,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/lang.module.js